import React, { Fragment } from 'react';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { GoTopViewGraphic } from '../../../../images/LandingPageNYC/NYCImageLinks';
import { GoSideView } from '../../../../images/LandingPageNYC/NYCImageLinks';
import Button from '../../../../artzu-ui/src/Button';

const WhyWait = () => (
  <Fragment>
    <div className="nyc-fleets-why-wait">
      <div className="nyc-fleets-why-wait__container">
        <div className="nyc-fleets-why-wait__left">
          <h2> Start Drivesharing Today</h2>
          <div className="nyc-fleets-why-wait__requirements">
            <h5> Requirements:</h5>
            <div className="nyc-fleets-why-wait__requirements--condition">
              <FontAwesomeIcon icon={faCheckCircle} fixedWidth size="1x" color="#128DFF" style={{ height: '2em' }} />
              <p>Must be 21 or older</p>
            </div>
            <div className="nyc-fleets-why-wait__requirements--condition">
              <FontAwesomeIcon icon={faCheckCircle} fixedWidth size="1x" color="#128DFF" style={{ height: '2em' }} />
              <p>Meet TLC License requirements</p>
            </div>
            <Link to="/signup">
              <Button label="Sign Up" primary color="#128DFF" size="xl" className="nyc-fleets-why-wait__button" />
            </Link>
          </div>
        </div>
        <div className="nyc-fleets-why-wait__right">
          <img className="nyc-fleets-why-wait__right--img--mobile" src={GoTopViewGraphic} alt="car" />
          <img className="nyc-fleets-why-wait__right--img--desktop" src={GoSideView} alt="car" />
        </div>
      </div>
    </div>
  </Fragment>
);

export default WhyWait;



// WEBPACK FOOTER //
// ./src/components/Static/NYCFleets/Shared/WhyWait.js